/**
 * Drill-down state for Engagement Insights.
 *
 * When the internal Trust Marketplace CBO selects a specific CBO in the
 * "Compare CBOs" table, this context exposes the target_cbo_id so every
 * card inside the panel re-fetches via the /cbo/{id}/... drill-down endpoints
 * instead of the consolidated/own-CBO endpoints. Setting to null clears.
 */

import React, { createContext, useContext, useState } from 'react';

interface DrillDownState {
  drillCboId: number | null;
  drillCboName: string | null;
  setDrill: (id: number | null, name?: string | null) => void;
}

const Ctx = createContext<DrillDownState>({
  drillCboId: null,
  drillCboName: null,
  setDrill: () => {},
});

export const DrillDownProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<{ id: number | null; name: string | null }>({
    id: null,
    name: null,
  });
  const value: DrillDownState = {
    drillCboId: state.id,
    drillCboName: state.name,
    setDrill: (id, name = null) => setState({ id, name }),
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export function useDrillDown(): DrillDownState {
  return useContext(Ctx);
}
